import axios from 'axios' 

const resource = '/api/ponudastavka';

export default {
    getAll(ponudaid) {
        return axios.post(`${resource}/getall`, null, {params:{
          ponudaid: ponudaid
        }});
    },
    getOne(id) {
        return axios.get(`${resource}/?id=${id}`);
    },
    create(payload) {
        return axios.post(`${resource}/create`, payload);
    },
    update(payload, id) {
        return axios.put(`${resource}/${id}`, payload);
    },
    delete(id) {
        return axios.delete(`${resource}/${id}`)
    },
    
    // MANY OTHER ENDPOINT RELATED STUFFS
};